export default defineNuxtRouteMiddleware((to, from) => {
  const businessStore = useBusinessStore();
  const { clearBooking, clearMembership, clearCart, clearGiftCard } =
    businessStore;

  const getModule = (path: string) => {
    if (path.includes("/booking")) return "booking";
    if (path.includes("/memberships")) return "memberships";
    if (path.includes("/products") || path.includes("/cart")) return "products";
    if (path.includes("/gift-cards")) return "gift-cards";
    return null;
  };

  const fromModule = getModule(from.path);
  const toModule = getModule(to.path);

  // If we are leaving a module and NOT entering the same module (even a sub-page)
  if (fromModule && fromModule !== toModule) {
    switch (fromModule) {
      case "booking":
        if (
          businessStore.goToCheckout &&
          (to.path.includes("/sign-in") || to.path.includes("/complete"))
        ) {
          break;
        }
        clearBooking();
        break;
      case "memberships":
        if (
          businessStore.goToCheckoutMembership &&
          (to.path.includes("/sign-in") || to.path.includes("/complete"))
        ) {
          break;
        }
        clearMembership();
        break;
      case "products":
        if (
          businessStore.goToOrderSummary &&
          (to.path.includes("/sign-in") || to.path.includes("/complete"))
        ) {
          break;
        }
        clearCart();
        break;
      case "gift-cards":
        if (
          businessStore.goToGiftCardSummary &&
          (to.path.includes("/sign-in") || to.path.includes("/complete"))
        ) {
          break;
        }
        clearGiftCard();
        break;
    }
  }
});
